module.exports = __webpack_public_path__ + "static/media/ChatGPT Image Sep 16, 2025, 06_05_08 PM.3b1735c7.png";